import axiosInstance from 'helpers/axiosInstance';

import { UserAccount } from './account.types';

export interface UpdateAccountVars
  extends Pick<
    UserAccount,
    | 'id'
    | 'birthDate'
    | 'firstName'
    | 'lastName'
    | 'phoneNumber'
    | 'insuranceCarrier'
    | 'email'
  > {}

export const updateAccount = (
  patch: UpdateAccountVars,
): Promise<UserAccount> => {
  return axiosInstance
    .patch(`/patients/accounts/${patch.id}`, {
      account: patch,
    })
    .then(response => response.data.account);
};
